module.exports = __webpack_public_path__ + "static/media/login_icon.72619c5b.svg";